<template>
  <div v-if="!item.hidden">
    <!-- 无子菜单：直接渲染菜单项 -->
    <template v-if="!hasChildren(item)">
      <app-link :to="resolvePath(item.path)">
        <el-menu-item :index="resolvePath(item.path)">
          <i :class="(item.meta && item.meta.icon) || 'el-icon-document'" />
          <span slot="title">{{ item.meta && item.meta.title }}</span>
        </el-menu-item>
      </app-link>
    </template>

    <!-- 只有一个可见子项：扁平化显示 -->
    <template v-else-if="hasOneShowingChild(item.children)">
      <app-link :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)">
          <i :class="(onlyOneChild.meta && onlyOneChild.meta.icon) || 'el-icon-document'" />
          <span slot="title">{{ onlyOneChild.meta && onlyOneChild.meta.title }}</span>
        </el-menu-item>
      </app-link>
    </template>

    <!-- 多个子项：渲染子菜单 -->
    <el-submenu v-else :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <i :class="(item.meta && item.meta.icon) || 'el-icon-folder'" />
        <span>{{ item.meta && item.meta.title }}</span>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :item="child"
        :base-path="resolvePath(item.path)"
        :is-nest="true"
      />
    </el-submenu>
  </div>
</template>

<script>
import AppLink from './Link.vue'

export default {
  name: 'SidebarItem',
  components: { AppLink },
  props: {
    item: { type: Object, required: true },
    basePath: { type: String, default: '' },
    isNest: { type: Boolean, default: false }
  },
  data() {
    return {
      onlyOneChild: null
    }
  },
  methods: {
    hasChildren(item) {
      return item.children && item.children.length > 0
    },
    hasOneShowingChild(children = []) {
      const showingChildren = children.filter(child => {
        if (child.hidden) return false
        this.onlyOneChild = child
        return true
      })
      return showingChildren.length === 1
    },
    resolvePath(routePath) {
      if (!routePath) return this.basePath || '/'
      if (/^(https?:|mailto:|tel:)/.test(routePath)) return routePath
      if (routePath.startsWith('/')) return routePath
      const base = (this.basePath || '').replace(/\/+$/, '')
      return `${base}/${routePath}`.replace(/\/+/g, '/')
    }
  }
}
</script>
